import React, { useState, useEffect } from 'react';
import AttestedModalMobile from './attestedModalMobile';
import AttestedModalWeb from './attestedModalWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const AttestedModalRouter = (props) => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  if (width === 0) {
    return null;
  }

  return width < MOBILE_BREAKPOINT ? (
    <AttestedModalMobile {...props} />
  ) : (
    <AttestedModalWeb {...props} />
  );
};

export default AttestedModalRouter;
